import { style, animate, transition, trigger, query, group } from '@angular/animations';

export const ROUTE_ANIMATION_TIME: number = 200;

export class RouteAnimations {

    /**
     * Slide page up on enter and down on leave
     */
    public static slideUpDown(time: number = ROUTE_ANIMATION_TIME) {
        return trigger('upRouteAnimation', [
            transition(':increment', this.slideEnter('up', time)),
            transition(':decrement', this.slideLeave('down', time))
        ]);
    }

    /**
     * Slide page left on enter and right on leave
     */
    public static slideLeftRight(time: number = ROUTE_ANIMATION_TIME) {
        return trigger('leftRouteAnimation', [
            transition(':increment', this.slideEnter('left', time)),
            transition(':decrement', this.slideLeave('right', time))
        ]);
    }

    private static slideEnter(position: 'left' | 'up', time: number) {
        const startPosition = position == 'left' ? 'translateX(100%)' : 'translateY(100%)'; 
        const endPosition = position == 'left' ? 'translateX(0%)' : 'translateY(0%)';

        return [
            // Position the entering page on top of leaving page
            query(':enter', style({ position: 'fixed', 'z-index': '1', width: '100%', height: '100dvh' }), { optional: true }),
            query(':leave', style({ position: 'fixed', 'z-index': '0', width: '100%', height: '100dvh' }), { optional: true }),
            // Slide in entering page
            query(':enter', [
                style({ transform: startPosition }),
                animate(`${time}ms ease-in-out`, style({ transform: endPosition }))
            ], { optional: true })
        ]
    }

    private static slideLeave(position: 'right' | 'down', time: number) {
        const startPosition = position == 'right' ? 'translateX(0%)' : 'translateY(0%)';
        const endPosition = position == 'right' ? 'translateX(100%)' : 'translateY(100%)'; 
        
        return [
            // Position the entering page on top of leaving page
            query(':enter', style({ position: 'fixed', 'z-index': '0', width: '100%', height: '100dvh' }), { optional: true }),
            query(':leave', style({ position: 'fixed', 'z-index': '1', width: '100%', height: '100dvh' }), { optional: true }),
            // Slide out entering page
            query(':leave', [
                style({ transform:  startPosition }),
                animate(`${time}ms ease-in-out`, style({ transform: endPosition }))
            ], { optional: true })
        ]
    }

    /**
     * Slide in page overlay and fade in its background
     * @param overlayClass The class selector of the overlay div to slide in from right
     * @param backgroundClass The class selector of the background div to fade in behind overlay
     */
    public static openCloseOverlay(overlayClass: string = '', backgroundClass: string = '', time: number = ROUTE_ANIMATION_TIME) {
        return trigger('openCloseOverlay', [
            transition('close => open', [
                group([
                    // Slide in overlay
                    query(`:enter ${overlayClass}`, [
                        style({ transform: 'translateX(100%)' }),
                        animate(`${time}ms ease-in-out`, style({ transform: 'translateX(0%)' }))
                    ], { optional: true }),
                    // Fade in background
                    query(`:enter ${backgroundClass}`, [
                        style({ opacity: 0 }),
                        animate(`${time}ms`, style({ opacity: 1 }))
                    ], { optional: true })
                ])
            ]),
            transition('open => close', [
                group([
                    // Slide out overlay
                    query(`:leave ${overlayClass}`, [
                        style({ transform: 'translateX(0%)' }),
                        animate(`${time}ms ease-in-out`, style({ transform: 'translateX(100%)' }))
                    ], { optional: true }),
                    // Fade out background
                    query(`:leave ${backgroundClass}`, [
                        style({ opacity: 1 }),
                        animate(`${time}ms`, style({ opacity: 0 }))
                    ], { optional: true }),
                ])
            ])
        ])
    }
    }
